import { format } from "date-fns";

import {
  createSlice,
  createAsyncThunk,
} from '@reduxjs/toolkit'


const initialState = {
  reportData: {
    status: "idle",
    data: [],
    error: {},
  },
}

export const fetchReport = createAsyncThunk('preport', async (data) => {
    const {token} = data
       const axios = require("axios")
       const headers = {
                 "Authorization" : `Bearer ${token}`,
                 "Access-Control-Allow-Origin" : "*",
                 "Access-Control-Allow-Headers": "Origin, X-Requested-With, Content-Type, Accept",
              }
      const url = `/api/v0/greenhouse/YILI` 

       const response = await axios.get(url, 
                 { headers })
      return response.data
})

const plantingReportSlice = createSlice({
  name: 'preport',
  initialState: initialState,
  reducers: {},
  extraReducers: {
    [fetchReport.pending.type]:(state, action) => {
      state.reportData = {
        status: "loading",
        data: [],
        error: {},
      }
    },
    [fetchReport.fulfilled.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: action.payload,
        error: {},
      }
    },
    [fetchReport.rejected.type]:(state, action) => {
      state.reportData = {
        status: "idle",
        data: [],
        error: "unauthorized",
      }
    },
  }
})

export default plantingReportSlice.reducer
